export default __webpack_public_path__ + "assets/images/cfed2657905f9f13a23d9356ebcc9642.png";